import React, { useEffect, useState } from "react";
import { PrinterOutlined, SaveOutlined } from "@ant-design/icons";
import { testCashDrawerOpen } from "../../services/print-sevice/print";
import useUserStore from "../../stores/store";

/**
 * This component should be used other places and everything should be done inside it or its child component but recommended not pass any data to its invoked page or component
 *
 * @param {*}
 * @returns
 */
export default function PrinterSettingsCashDrawer({ settingsData, cashDrawerCommands, onHandleSave }) {
  const [cashDrawerCommand, setCashDrawerCommand] = useState("");
  const { showNotification } = useUserStore();

  const handleCommandClick = (commandObj) => {
    setCashDrawerCommand(commandObj.command);
  }

  const onHandleSaveCommand = () => {
    onHandleSave(cashDrawerCommand);
  };

  const onHandleTestCommand = () => {
    testCashDrawerOpen(settingsData, cashDrawerCommand, showNotification);
  };

  useEffect(() => {
    setCashDrawerCommand(settingsData.cashDrawerCommand);
  }, [settingsData]);

  return (
    <div>
      {settingsData.printerName && (
        <div>
          <div><span className="font-bold">Printer:</span> {settingsData.printerName}</div>
          {cashDrawerCommands.map((item, indx) => (
            <div
              key={indx}
              className={`p-2 mt-5 cursor-pointer ${
                item.command === cashDrawerCommand ? "bg-[#2EC114] text-white font-semibold" : ""
              }`}
              style={{
                border: "1px solid #2EC114", // primary color
                borderRadius: "8px",
              }}
              onClick={() => handleCommandClick(item)}
            >
              {item.commandName}
            </div>
          ))}

          <div className="w-[300px] flex m-auto justify-between pt-10 ">
            <button
              key="kitchenSlipOrInvoice"
              className="bg-[#2EC114] text-[#FFFFFF] rounded-[5px] font-semibold w-[110px]"
              onClick={() => onHandleSaveCommand()}
              style={{
                padding: "8px 16px",
              }}
            >
              <SaveOutlined style={{ marginRight: 6 }} />
              Save
            </button>

            <button
              key="printOrDownload"
              onClick={() => onHandleTestCommand()}
              className="bg-yellow text-[#000000] rounded-[5px] font-semibold "
              style={{
                padding: "8px 16px",
              }}
            >
              <PrinterOutlined style={{ marginRight: 6 }} />
              Test Cash Drawer
            </button>
          </div>
        </div>
      )}
      {!settingsData.printerName && (
        <div
          className="p-5  mt-2 min-h-[76px] text-center"
          style={{
            border: "1px solid #FA6060", // primary color
            borderRadius: "8px",
          }}
        >
          Kindly set invoice printer and then set cash drawer
        </div>
      )}
    </div>
  );
}
